import CommonPopup from './CommonPopup';

export default CommonPopup;
